/* components/ImageColumns */

import { Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";
// eslint-disable-next-line max-len
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, Thumbs, Controller, SwiperOptions, Mousewheel, EffectFade, Zoom, FreeMode } from 'swiper';
import 'swiper/css/bundle';
Swiper.use([Navigation, FreeMode]);

@Component
export class ImageColumns extends ThemeComponent {
    private container!: HTMLElement;
    private resizeObserver!: ResizeObserver;

    columnCarousel: Swiper | undefined = undefined;

    init(): void {
        this.container = this as HTMLElement;

        if (!this.container) {return;}

        this.updateJustifyContent();

        window.addEventListener('resize', this.updateJustifyContent.bind(this));

        this.resizeObserver = new ResizeObserver(() => {
            this.updateJustifyContent();
        });

        this.resizeObserver.observe(this.container);

        const imageColumnsCarousel = this.querySelector('.image-columns__content--sidescroll-wrapper') as HTMLElement;
        if (this.classList.contains('image-columns__content--sidescroll-wrapper')) {
            this.initaliseSwiper(this);
        }
    }


    private initaliseSwiper(imageColumnsCarousel: HTMLElement): void {
        this.columnCarousel = new Swiper(imageColumnsCarousel, {
            freeMode: true,
            spaceBetween: 10,
            slidesPerView: 1.5,
            breakpoints: {
                768: { slidesPerView: 3.5 },
                1024: { slidesPerView: 5.5 },
                1440: { slidesPerView: 7 }
            }
        });
    }

    private updateJustifyContent(): void {
        const isOverflowing = this.container.scrollWidth > this.container.clientWidth;
        this.container.classList.toggle('image-columns__content--centered', !isOverflowing);
    }

    private destroySwipers(): void {
        if (this.columnCarousel) {
            this.columnCarousel.destroy(true, true);
            this.columnCarousel = undefined;
        }
    }

    destroy(): void {
        window.removeEventListener('resize', this.updateJustifyContent.bind(this));
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }

        this.destroySwipers();
    }
}
